export default __webpack_public_path__ + "static/media/facebook.acd66cb0.svg";